import React, { createRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash';

import { Grid } from '~/components';
import api from '~/services/api';
import {
  storeInRequest,
  recordFiltering,
  resetFiltering,
} from '~/store/modules/estoqueproduto/actions';

import { Graph, RefreshStock } from './components';

export default function EstoqueProduto() {
  const estoqueProduto = useSelector((state) => state.estoqueproduto);

  const [posto, setPosto] = useState(false);
  const [combo, setCombo] = useState([]);

  const refStock = createRef();

  async function handleTogglePostoComboio() {
    const { data } = await api.get('usuarioposto', {
      params: { pagesize: 99999 },
    });

    await setCombo(data.items);
  }

  async function handleToggleCombo(value) {
    await setPosto(false);

    if (!isEmpty(value.combo)) {
      await setPosto(value.combo.post_cod_posto);
    }
  }

  useEffect(() => {
    handleTogglePostoComboio();
  }, []);

  return (
    <>
      <Grid
        state={estoqueProduto}
        read={storeInRequest}
        filter={recordFiltering}
        reset={resetFiltering}
        timeOut={60000} //99999999999  60000 = 1 minuto
        // timeOut={3000}
        component={(props) => (
          <Graph
            {...props}
            refresh={(product) => refStock.current.handleToggleModal(product)}
          />
        )}
        unique={{
          wherefield: 'post_cod_posto',
          valuewherefield: posto,
          typewherefield: 'EQUALS',
        }}
        toolbar={[
          {
            type: 'select',
            name: 'combo',
            options: combo,
            label: 'post_desc',
          },
        ]}
        changeToolbar={(value) => handleToggleCombo(value)}
        onStart={!!posto}
      />

      <RefreshStock ref={refStock} />
    </>
  );
}
